<script>
	import { getContext } from "svelte";
  import { LayerCake, Svg, Html, groupLonger, flatten } from "layercake";
  import { px } from '../../utils'

	const { rScale } = getContext("LayerCake");

  const PADDING = 5;

  export let fill;
  export let suffix = '';
  export let textColor = '#BDBDBD';
  export let width;
  export let height;
  export let formatValue = value => value

  $: ticks = $rScale.ticks()
  $: minValue = ticks[0];
  $: maxValue = ticks[ticks.length - 2];

  $: minRadius = $rScale(minValue);
  $: maxRadius = $rScale(maxValue);

</script>

 <svg {width} {height}>
  <g transform={`translate(${PADDING}, ${PADDING})`}>
    <circle 
      class="Legend__circle"
      cx={maxRadius}
      cy={maxRadius}
      r={maxRadius}
      stroke={fill}
      fill={fill}
      fill-opacity={0.5}
    />
    <circle 
      class="Legend__circle"
      cx={maxRadius}
      cy={maxRadius*2 - minRadius}
      r={minRadius}
      stroke={fill}
      fill={fill}
      fill-opacity={0.5}
    />
    <line
      class="Legend__line"
      x1={maxRadius}
      y1={0}
      x2={maxRadius + 50}
      y2={0}
      stroke={textColor}
    />
    <line
      class="Legend__line"
      x1={maxRadius}
      y1={maxRadius*2 - minRadius*2}
      x2={maxRadius + 50}
      y2={maxRadius*2 - minRadius*2}
      stroke={textColor}
    />
    <text x={maxRadius + 50 + 5} y={0} class="Legend__text" fill={textColor}>
      {formatValue(maxValue) + suffix}
    </text>
    <text x={maxRadius + 50 + 5} y={maxRadius*2 - minRadius*2} class="Legend__text" fill={textColor}>
      {formatValue(minValue) + suffix}
    </text>
  </g>
 </svg>
	

<style lang="scss">
	.Legend {    
    &__line {
      stroke-dasharray: 2;
      stroke-width: .5px;
    }

    &__text {
      stroke: none;
      dominant-baseline: central;
      font-size: 14px;
    }

  }
  svg {
      align-self: last baseline;
    }
</style>
